import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import "../assets/css/sparsh_style.css";
import "../assets/css/Responsive/sparsh_responsive.css";
import gall1 from "../assets/images/sparsh/sparsh.webp";
import gall2 from "../assets/images/sparsh/garden.webp";
import gall3 from "../assets/images/sparsh/gate.webp";
import gall4 from "../assets/images/sparsh/Cam_11.webp";
import gall5 from "../assets/images/sparsh/garden1.webp";
import gall6 from "../assets/images/sparsh/Living Final.webp";
import ame1 from "../assets/images/sparsh/amenities/amenity1.webp";
// import ame2 from "../assets/images/sparsh/amenities/amenity2.webp";
import ame3 from "../assets/images/sparsh/amenities/amenity3.webp";
import ame4 from "../assets/images/sparsh/amenities/amenity4.webp";
import ame5 from "../assets/images/sparsh/amenities/amenity5.webp";
import ame6 from "../assets/images/sparsh/amenities/amenity6.webp";
import ame7 from "../assets/images/sparsh/amenities/amenity7.webp";
import ame8 from "../assets/images/sparsh/amenities/amenity8.webp";
// import ame9 from "../assets/images/sparsh/amenities/amenity9.webp";
import ame10 from "../assets/images/sparsh/amenities/amenity10.webp";
// import ame11 from "../assets/images/sparsh/amenities/amenity11.webp";
// import ame12 from "../assets/images/sparsh/amenities/amenity12.webp";
// import ame13 from "../assets/images/sparsh/amenities/amenity13.webp";
import ame14 from "../assets/images/sparsh/amenities/amenity14.webp";
import ame15 from "../assets/images/sparsh/amenities/amenity15.webp";
import ame16 from "../assets/images/sparsh/amenities/amenity16.webp";
import ame17 from "../assets/images/sparsh/amenities/amenity17.webp";
import ame18 from "../assets/images/sparsh/amenities/amenity18.webp";
import ame19 from "../assets/images/sparsh/amenities/amenity19.webp";
import ame20 from "../assets/images/sparsh/amenities/amenity20.webp";
import ame21 from "../assets/images/sparsh/amenities/amenity21.webp";
import ame22 from "../assets/images/sparsh/amenities/amenity22.webp";
import ame23 from "../assets/images/sparsh/amenities/amenity23.webp";
import ame24 from "../assets/images/sparsh/amenities/amenity24.webp";
import ame25 from "../assets/images/sparsh/amenities/amenity25.webp";
import ame26 from "../assets/images/sparsh/amenities/amenity26.webp";
import rightimg from "../assets/images/sparsh/5.webp";
import spec1 from "../assets/images/sparsh/spec1.webp";
import spec2 from "../assets/images/sparsh/spec2.webp";
import spec3 from "../assets/images/sparsh/spec3.webp";
import spec4 from "../assets/images/sparsh/spec4.webp";
import spec5 from "../assets/images/sparsh/spec6.webp";
import spec6 from "../assets/images/sparsh/spec7.webp";

const images = [gall1, gall2, gall3, gall4, gall5, gall6];
const imags = [rightimg, gall1, gall2, gall3, gall4, gall5, gall6];

export default function Sparsh() {
  const [modalImg, setModalImg] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact: "",
  });
  // const [showForm, setShowForm] = useState(false);
  const [showBrochureForm, setShowBrochureForm] = useState(false);
  const [showFloorPlanForm, setShowFloorPlanForm] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const openModal = (src) => {
    setModalImg(src);
  };

  const closeModal = () => {
    setModalImg(null);
  };

  document.title = "Sanvicasa - Project | Sparsh";

  const [showModal, setShowModal] = useState(false);

  const allAmenities = [
    { image: ame1, name: "Children's Play Area" },
    { image: ame21, name: "water lily pond" },
    // { image: ame2, name: "Box Cricket" },
    { image: ame3, name: "Landscape Garden" },
    { image: ame4, name: "Senior Citizen Sit-Out" },
    { image: ame5, name: "Meditation Area" },
    { image: ame16, name: "Lawn" },
    { image: ame6, name: "Club House" },
    { image: ame7, name: "Gym" },
    { image: ame8, name: "Indoor Games" },
    // { image: ame9, name: "Gym" },
    { image: ame10, name: "Parking Area" },
    // { image: ame11, name: "Gym" },
    // { image: ame12, name: "Gym" },
    // { image: ame13, name: "Sitting Area" },
    { image: ame26, name: "Zen Garden" },
    { image: ame25, name: "Tv Room" },
    { image: ame14, name: "Security" },
    { image: ame24, name: "Lounge" },
    { image: ame23, name: "Library" },
    { image: ame19, name: "Multipurpose hall" },
    { image: ame15, name: "Solar Panels" },
    { image: ame18, name: "Art wall" },
    { image: ame20, name: "Entrance water cascade" },
    { image: ame22, name: "Entry / exit wicket gate" },
    { image: ame17, name: "Bird feeder" },
  ];

  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 4000); // change every 4s
    return () => clearInterval(interval);
  }, []);
  return (
    <div>
      <div className="sparsh_container">
        <section className="sparsh_sec1" data-aos="fade-down">
          <div className="projects">
            <div className="sparsh" data-aos="zoom-in">
              <h1>sanvicasa sparsh</h1>
              <div className="proj-detail">
                <div className="first-det" data-aos="fade-right">
                  <svg
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 24 24"
                    xmlSpace="preserve"
                    className="w-6 h-6"
                  >
                    <line
                      className="st0"
                      x1="14.9"
                      y1="6.7"
                      x2="14.9"
                      y2="15.1"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <line
                      className="st0"
                      x1="14.9"
                      y1="20.2"
                      x2="14.9"
                      y2="14.2"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <line
                      className="st0"
                      x1="14.9"
                      y1="14.2"
                      x2="18"
                      y2="15.7"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M18,20.1V6.7c0-0.4-0.1-0.7-0.3-1c-0.7-0.6-1.5-1.1-2.3-1.6c-0.3-0.2-0.7-0.4-1.1-0.2L6.6,7.7
              C6.2,8,5.9,8.4,5.8,8.9v7.4"
                      stroke="#FFFFFF"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <line
                      x1="5.9"
                      y1="12.2"
                      x2="14.9"
                      y2="9.3"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M4,20.2v-2.4c0-0.6,0.3-1.1,0.8-1.3l1-0.2l9.1-2.1l0,0"
                      stroke="#FFFFFF"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M18,9.3l1.7,1.7c0.3,0.3,0.4,0.6,0.4,1v8"
                      stroke="#FFFFFF"
                      fill="none"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <line
                      x1="21"
                      y1="20.2"
                      x2="3"
                      y2="20.2"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <p>3 BHK Flats & Shops</p>
                </div>
                <div
                  className="sec-det"
                  data-aos="fade-left"
                  data-aos-delay="200"
                >
                  <svg
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    x="0px"
                    y="0px"
                    viewBox="0 0 24 24"
                    xmlSpace="preserve"
                    className="w-6 h-6"
                  >
                    <line
                      x1="5.8"
                      y1="21"
                      x2="18.2"
                      y2="21"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                    <circle
                      cx="12"
                      cy="9.9"
                      r="2.8"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                    <path
                      d="M18.9,9.9C18.9,16.1,12,21,12,21S5.1,16.1,5.1,9.9C5.1,6.1,8.2,3,12,3S18.9,6.1,18.9,9.9z"
                      stroke="#FFFFFF"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      fill="none"
                    />
                  </svg>
                  <p>South Bopal Ahmedabad</p>
                </div>
                <div
                  className="third-det"
                  data-aos="fade-up"
                  data-aos-delay="400"
                >
                  <div class="progress-circle p100">
                    <span>100</span>
                    <div class="left-half-clipper">
                      <div class="first50-bar"></div>
                      <div class="value-bar"></div>
                    </div>
                  </div>

                  <p>Ready To Move In</p>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* section 2 */}
        <section className="sparsh_sec2" data-aos="fade-up">
          <div className="overview">
            <div className="tower-detail">
              <h3>2</h3>
              <p>Tower</p>
            </div>
            <div className="commercial-unit">
              <h3>14</h3>
              <p>Commercial Unit</p>
            </div>
            <div className="basement">
              <h3>1</h3>
              <p>Basement</p>
            </div>
            <div className="balcony">
              <h3>8 X 4</h3>
              <p>Proper sitting Balcony</p>
            </div>
            <div className="apartment">
              <h3>94</h3>
              <p>Residential Apartment</p>
            </div>
            <div className="bhk">
              <h3>ALL</h3>
              <p>3BHK</p>
            </div>
            <div className="rise-building">
              <h3>Low</h3>
              <p>12 Rise Building</p>
            </div>
            <div className="resident-size">
              <h3>Residential Size</h3>
              <p>1758 sq ft</p>
            </div>
            <div className="Commercial-Shops-Size">
              <h3>Commercial Shops Size</h3>
              <p>1000 sq ft to 1300 sq ft</p>
            </div>
          </div>
          <p className="para-det">
            Precisely planned 3 BHK flats & shops mark an opulent arrival in one
            of the finest prime locality.
          </p>
          {/* <div className="overview-btns">
            <button>Brochure</button>
            <button>Floor Plans</button>
          </div> */}
          <div className="overview-btns">
            <button onClick={() => setShowBrochureForm(true)}>Brochure</button>
            {/* <button onClick={() => setShowFloorPlanForm(true)}>
              Floor Plan
            </button> */}
            <Link to="/contact">
              <button>Contact Us</button>
            </Link>
          </div>
        </section>

        {/* section 3 */}
        <section className="sparsh_sec3">
          <h2 data-aos="fade-right">Gallery</h2>
          <h1 data-aos="fade-left">Space For Togetherness</h1>
          <div className="gallery-images">
            {images.map((src, index) => (
              <div
                className="img-wrapper"
                key={index}
                data-aos="zoom-in"
                data-aos-delay={index * 100}
              >
                <img
                  src={src}
                  alt={`Gallery ${index}`}
                  onClick={() => openModal(src)}
                />
              </div>
            ))}
          </div>
        </section>

        {/* Modal */}
        {modalImg && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="close-button" onClick={closeModal}>
                x
              </button>
              <img src={modalImg} alt="Full View" className="modal-img" />
            </div>
          </div>
        )}

        <section className="saharsh_sec4" data-aos="fade-up">
          <div className="outer">
            <div className="inner">
              <div className="left-inner">
                <div className="heading">
                  <p>
                    Amenities<div className="long-bar"></div>
                  </p>
                </div>
                <div className="amenities">
                  {allAmenities.slice(0, 6).map((amenity, index) => (
                    <div className="amenities-box" key={index}>
                      <div className={`ame${index + 1}`}>
                        <img src={amenity.image} alt={`Amenity${index + 1}`} />
                      </div>
                      <div className="ame-detail">
                        <p>{amenity.name}</p>
                      </div>
                    </div>
                  ))}
                </div>
                <button onClick={() => setShowModal(true)}>
                  View All Amenities
                </button>
              </div>
              {/* <div className="right-inner">
                <img src={rightimg} alt="amenity-rightside" />
              </div> */}
              {/* <div className="right-inner relative w-[400px] h-[250px] overflow-hidden">
                <img
                  src={imags[current]}
                  alt="slide"
                  className="w-full h-full object-cover rounded-xl transition-all duration-700"
                />
              </div> */}
              <div className="right-inner">
                <div
                  className="slider-track"
                  style={{ transform: `translateX(-${current * 100}%)` }}
                >
                  {imags.map((img, i) => (
                    <img key={i} src={img} alt={`slide-${i}`} />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Modal */}
        {showModal && (
          <div
            className="amenities-modal-backdrop"
            onClick={() => setShowModal(false)}
          >
            <div
              className="amenities-modal"
              onClick={(e) => e.stopPropagation()}
            >
              <h2 className="modal-heading">All Amenities</h2>
              <div className="modal-amenities-grid">
                {allAmenities.map((amenity, index) => (
                  <div className="amenities-box" key={index}>
                    <img src={amenity.image} alt={`Amenity${index + 1}`} />
                    <p>{amenity.name}</p>
                  </div>
                ))}
              </div>
              <button
                className="modal-close-btn"
                onClick={() => setShowModal(false)}
              >
                Close
              </button>
            </div>
          </div>
        )}

        <section className="sparsh_sec5" data-aos="fad">
          <div className="specification" data-aos="fade-up">
            <div className="heading">
              <p>
                Specifications<div className="long-bar"></div>
              </p>
            </div>
          </div>
          <div className="specific-details">
            <div className="spec-box" data-aos="fade-right">
              <img src={spec1} alt="specification1" />
              <p>Flooring</p>
              <ul>
                <li>
                  Living, Dining- Premium Quality Vitrified Tiles 800x800mm
                </li>
                <li>
                  Bedrooms, Kitchen- Premium Quality Vitrified Tiles 600x600mm
                </li>
                <li> Porch, Wash - Rustic Tiles. Kota</li>
              </ul>
            </div>
            <div className="spec-box" data-aos="fade-left">
              <img src={spec2} alt="specification2" />
              <p>Kitchen</p>
              <ul>
                <li>Platform - Granite with SS Sink</li>
                <li>Tiles - Decorative Vitrified Tiles</li>
                <li>
                  Designer Vitrified Tiles dado Up to Lintel Level &amp; Wall
                  Above Kitchen Platform
                </li>
              </ul>
            </div>
            <div className="spec-box" data-aos="fade-right">
              <img src={spec3} alt="specification3" />
              <p>Bathrooms</p>
              <ul>
                <li>Wall - Decorative Vitrified Tiles</li>
                <li>Plumbing - Branded Concealed Bath Fittings</li>
                <li> Sanitary - Branded Table TOPS &amp; Wall Hung Commodes</li>
              </ul>
            </div>
            <div className="spec-box" data-aos="fade-left">
              <img src={spec4} alt="specification4" />
              <p>Doors</p>
              <ul>
                <li>Main Door - Designer Main Door with Wooden Frame</li>
                <li>
                  Internal Doors - Wooden Flush Doors With Premium Fittings
                </li>
              </ul>
            </div>
            <div className="spec-box" data-aos="fade-right">
              <img src={spec5} alt="specification5" />
              <p>Electric</p>
              <ul>
                <li>
                  All Areas - Concealed FR ISI Wiring with adequate number of
                  points in each room with branded Modular Switches.
                </li>
                <li>
                  AC provision in all bed rooms with concealed drain pipe and
                  copper cabling.
                </li>
              </ul>
            </div>
            <div className="spec-box" data-aos="fade-left">
              <img src={spec6} alt="specification6" />
              <p>Color</p>
              <ul>
                <li>Internal - Mala Plaster With Putty finish</li>
                <li>External - Double Coat mala Plaster with Texture finish</li>
              </ul>
            </div>
          </div>
        </section>
      </div>
      <div className="brochure">
        {/* Brochure Modal */}
        {showBrochureForm && (
          <div
            className="modal-overlay"
            onClick={() => setShowBrochureForm(false)}
          >
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <h3>Request Brochure</h3>
              {submitted ? (
                <p>✅ Brochure will be sent to your email.</p>
              ) : (
                // <form
                //   onSubmit={(e) => {
                //     e.preventDefault();
                //     setSubmitted(true);
                //     setTimeout(() => {
                //       setShowBrochureForm(false);
                //       setSubmitted(false);
                //       setFormData({ name: "", email: "", contact: "" });
                //     }, 2000);
                //   }}
                // >
                //   <input
                //     type="text"
                //     placeholder="Your Name"
                //     value={formData.name}
                //     required
                //     onChange={(e) =>
                //       setFormData({ ...formData, name: e.target.value })
                //     }
                //   />
                //   <input
                //     type="email"
                //     placeholder="Your Email"
                //     value={formData.email}
                //     required
                //     onChange={(e) =>
                //       setFormData({ ...formData, email: e.target.value })
                //     }
                //   />
                //   <input
                //     type="tel"
                //     placeholder="Your Contact"
                //     value={formData.contact}
                //     maxLength={10}
                //     pattern="[0-9]{10}"
                //     required
                //     onChange={(e) => {
                //       const value = e.target.value;
                //       // Allow only numbers
                //       if (/^\d{0,10}$/.test(value)) {
                //         setFormData({ ...formData, contact: value });
                //       }
                //     }}
                //   />

                //   <button type="submit">Send Brochure</button>
                // </form>
                <form
                  onSubmit={async (e) => {
                    e.preventDefault();

                    const formDataToSend = new FormData();
                    formDataToSend.append(
                      "access_key",
                      "a78b83a8-b888-402a-ab79-9aea7f73fbad"
                    ); // 🔑 Replace with your Web3Forms key
                    formDataToSend.append("name", formData.name);
                    formDataToSend.append("email", formData.email);
                    formDataToSend.append("contact", formData.contact);
                    formDataToSend.append("message", "📘 Brochure Request");

                    try {
                      const response = await fetch(
                        "https://api.web3forms.com/submit",
                        {
                          method: "POST",
                          body: formDataToSend,
                        }
                      );

                      const result = await response.json();

                      if (result.success) {
                        Swal.fire({
                          icon: "success",
                          title: "Request Sent!",
                          text: "📘 Brochure will be sent to your email.",
                          confirmButtonColor: "#0a3d62",
                        });
                        setShowBrochureForm(false);
                        setFormData({ name: "", email: "", contact: "" });
                      } else {
                        Swal.fire({
                          icon: "error",
                          title: "Oops...",
                          text: "Something went wrong. Please try again.",
                        });
                      }
                    } catch (error) {
                      Swal.fire({
                        icon: "error",
                        title: "Network Error",
                        text: "Unable to connect. Please check your internet.",
                      });
                    }
                  }}
                >
                  <input
                    type="text"
                    placeholder="Your Name"
                    value={formData.name}
                    required
                    onChange={(e) =>
                      setFormData({ ...formData, name: e.target.value })
                    }
                  />
                  <input
                    type="email"
                    placeholder="Your Email"
                    value={formData.email}
                    required
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                  />
                  <input
                    type="tel"
                    placeholder="Your Contact"
                    value={formData.contact}
                    maxLength={10}
                    pattern="[0-9]{10}"
                    required
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d{0,10}$/.test(value)) {
                        setFormData({ ...formData, contact: value });
                      }
                    }}
                  />

                  <button type="submit">Send Brochure</button>
                </form>
              )}
              <button
                className="close-btn"
                onClick={() => setShowBrochureForm(false)}
              >
                ✖
              </button>
            </div>
          </div>
        )}

        {/* Floor Plan Modal */}
        {showFloorPlanForm && (
          <div
            className="modal-overlay"
            onClick={() => setShowFloorPlanForm(false)}
          >
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <h3>Request Floor Plan</h3>
              {submitted ? (
                <p>✅ Floor Plans will be sent to your email.</p>
              ) : (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    setSubmitted(true);
                    setTimeout(() => {
                      setShowFloorPlanForm(false);
                      setSubmitted(false);
                      setFormData({ name: "", email: "", contact: "" });
                    }, 2000);
                  }}
                >
                  <input
                    type="text"
                    placeholder="Your Name"
                    value={formData.name}
                    required
                    onChange={(e) =>
                      setFormData({ ...formData, name: e.target.value })
                    }
                  />
                  <input
                    type="email"
                    placeholder="Your Email"
                    value={formData.email}
                    required
                    onChange={(e) =>
                      setFormData({ ...formData, email: e.target.value })
                    }
                  />
                  <input
                    type="tel"
                    placeholder="Your Contact"
                    value={formData.contact}
                    maxLength={10}
                    pattern="[0-9]{10}"
                    required
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow only numbers
                      if (/^\d{0,10}$/.test(value)) {
                        setFormData({ ...formData, contact: value });
                      }
                    }}
                  />

                  <button type="submit">Send Floor Plan</button>
                </form>
              )}
              <button
                className="close-btn"
                onClick={() => setShowFloorPlanForm(false)}
              >
                ✖
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
